// extracted by mini-css-extract-plugin
export default {"root":"in-developing_root__nOIYJ","title":"in-developing_title__q6RVg","image":"in-developing_image__pmKiQ","back":"in-developing_back__Kf5nw"};